module.exports = __webpack_public_path__ + "static/media/fraud.279b96c9.svg";